module.exports = __webpack_public_path__ + "static/hotel-01-9686cda6072bb0c52630e225ad77a27d.jpg";